// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"84ee8e6f","510":"6113d060","777":"49c19866"}[chunkId] + ".chunk.js";
};